import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const P0 = { current_password: "", new_password: "", confirm: "" };

export const CuentaView = () => {
  const { user } = useAuth();
  const [f, setF] = useState(P0);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");
    if (f.new_password !== f.confirm) { setMsg("Las contraseñas nuevas no coinciden"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      setF(P0);
      toast.success("Contraseña actualizada");
    } catch (err) { setMsg(errMsg(err)); }
    finally { setBusy(false); }
  };

  return (
    <form className="panel" onSubmit={submit} style={{ maxWidth: 520 }} data-testid="cuenta-view">
      <h4>Mi cuenta</h4>
      <p className="note">{user.name} · {user.email} · {user.role === "admin" ? "Administrador" : "Psicólogo"}</p>
      <h4 style={{ marginTop: 18 }}>Cambiar contraseña</h4>
      <div style={{ display: "grid", gap: 10 }} className="fgrid2-single">
        <label className="note" style={{ color: "#fff", fontWeight: 700 }}>Contraseña actual<input type="password" value={f.current_password} onChange={set("current_password")} required autoComplete="current-password" data-testid="cuenta-current-input" /></label>
        <label className="note" style={{ color: "#fff", fontWeight: 700 }}>Nueva contraseña (mínimo 8 caracteres)<input type="password" value={f.new_password} onChange={set("new_password")} required minLength={8} autoComplete="new-password" data-testid="cuenta-new-input" /></label>
        <label className="note" style={{ color: "#fff", fontWeight: 700 }}>Repite la nueva contraseña<input type="password" value={f.confirm} onChange={set("confirm")} required minLength={8} autoComplete="new-password" data-testid="cuenta-confirm-input" /></label>
      </div>
      {msg && <p className="err" data-testid="cuenta-error">{msg}</p>}
      <button className="btn btn-sol" type="submit" disabled={busy} style={{ marginTop: 14 }} data-testid="cuenta-submit-btn">{busy ? "Guardando…" : "Cambiar contraseña"}</button>
    </form>
  );
};
